import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { InputNumber } from 'antd';
import { dropLast, path } from 'ramda';
import cx from 'classnames';

import withTranslatePlaceholder from 'components/hocs/withTranslatePlaceholder';
import withFieldWrapper from 'components/hocs/withFieldWrapper';

const getCorrectResult = (value, format) => {
    value = `${value}`;

    if (format.test(value)) {
        return value.toString().replace(/,/g, '.');
    } else {
        let result = dropLast(1, value.toString());

        while (!format.test(result) && result.length !== 0) {
            result = dropLast(1, result);
        }

        if (result.length === 0) {
            return null;
        }

        return result.replace(/,/g, '.');
    }
};

export class InputNumberMask extends Component {
    static propTypes = {
        className: PropTypes.string,
        meta: PropTypes.object,
        input: PropTypes.object,
        mask: PropTypes.object,
        formatter: PropTypes.func,
    }

    state = {
        value: path(['input', 'value'], this.props)
    }

    componentDidUpdate() {
        const changeToEmpty = this.state.value && !this.props.input.value;
        const needClear = isNaN(this.state.value);

        if (changeToEmpty || needClear) {
            this.onChange('');
        } else {
            if (this.props.input.value !== this.state.value) {
                this.setState({ value: this.props.input.value });
            }
        }
    }

    getInputClasses(className, { invalid, submitFailed }) {
        return cx(`${className || ''} input form-control`, { error: invalid && submitFailed });
    }

    onChange = (value) => {
        const { mask } = this.props;
        const result = value && mask ? getCorrectResult(value, mask) : value;

        this.props.input.onChange(result);
        this.setState({ value: result });
    }

    render() {
        const { className, meta, input, formatter, ...rest } = this.props;
        const classes = this.getInputClasses(className, meta);

        return (
            <InputNumber
                {...rest}
                {...input}
                onChange={this.onChange}
                type='text'
                value={this.state.value || ''}
                className={classes}
                formatter={value => formatter && !isNaN(value) ? formatter(this.state.value || '') : this.state.value || ''}
            />
        );
    }
}

export default withTranslatePlaceholder(withFieldWrapper(InputNumberMask));
